<template>
  <div class="molecule-tag-selector">
    <h3 :id="`tag-selector-title-${_uid}`" class="molecule-tag-selector__title">{{ title }}</h3>
    <div class="molecule-tag-selector__container" role="group" :aria-labelledby="`tag-selector-title-${_uid}`">
      <AtomTag
        v-for="tag in tags"
        :key="tag._id"
        :text="tag.name"
        :selected="selectedTags.includes(tag._id)"
        :editable="false"
        :removable="canDeleteAndCreateTags"
        @click="toggleTag(tag._id)"
        @remove="removeTag(tag._id)" />

      <AtomTag v-if="canDeleteAndCreateTags" ref="newTagInput" :editable="true" :placeholder="newTagPlaceholder" @tag-created="handleTagCreated" />
    </div>
  </div>
</template>

<script>
  import AtomTag from "../atoms/AtomTag.vue";

  export default {
    name: "MoleculeTagSelector",
    components: {
      AtomTag,
    },
    props: {
      title: {
        type: String,
        default: "Tags",
      },
      tags: {
        type: Array,
        default: () => [],
      },
      selectedTags: {
        type: Array,
        default: () => [],
      },
      newTagPlaceholder: {
        type: String,
        default: "otro",
      },
      canDeleteAndCreateTags: {
        type: Boolean,
        default: true,
      },
    },
    emits: ["tag-selected", "tag-removed", "tag-created"],
    data() {
      return {};
    },
    methods: {
      toggleTag(tagId) {
        this.$emit("tag-selected", tagId);
      },
      removeTag(tagId) {
        this.$emit("tag-removed", tagId);
      },
      handleTagCreated(tagName) {
        this.$emit("tag-created", tagName.toLowerCase());
      },
    },
  };
</script>

<style lang="scss" scoped>
  .molecule-tag-selector {
    &__title {
      margin: 0 0 12px 0;
      font-size: 16px;
      font-weight: 500;
      font-family: $newFont_medium;
      text-transform: capitalize;
      color: #3d3d3d;
    }

    &__container {
      @include Flex(row, flex-start, center);
      flex-wrap: wrap;
      gap: 12px 18px;
      width: 100%;
      position: relative;
      z-index: 1;
    }
  }
</style>
